import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { APPEARANCES } from './constants';

const Divider = ({ appearance = APPEARANCES.default }) => {
  const dividerClasses = classNames('ws-ui-divider', `ws-ui-divider--appearance-${appearance}`);

  return <hr className={dividerClasses} />;
};

Divider.propTypes = {
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
};

export default Divider;
